export default {
	obligate: 'OBLIGATE',
	allow: 'ALLOW',
	accept: 'ACCEPT',
	decline: 'DECLINE',
	hardToken: 'HARD',
	softToken: 'SOFT',
	failed: 'FAILED',
	success: 'SUCCESS',
};
